import styles from './not-found-error.module.css';

class NotFoundError extends HTMLElement {
    connectedCallback(): void {
        this.render();
    }

    render(): void {
        this.innerHTML = `
            <div class="${styles.notFoundContainer}">
                <div role="alert" class="${styles.notFoundError}">
                    <div class="${styles.notFoundCell}" data-testid="error-title">
                        <span>Error</span>
                    </div>
                    <div class="${styles.notFoundCell}" data-testid="sorry-message">
                        <h1>Sorry, the page you are looking for doesn't exist or has been moved.</h1>
                    </div>
                </div>
            </div>
        `;
    }
}

// Register the custom element
customElements.define('not-found-error', NotFoundError);

export { NotFoundError };
